import * as React from 'react';

import { EntityActions, EntityType } from 'common/entity';
import { Route, RouteComponentProps } from 'react-router-dom';

import { AppState } from 'common/models/AppState';
import { Chapter } from 'common/api/models/Chapter';
import { ChaptersDialog } from './ChaptersDialog';
import { ChaptersTable } from './ChaptersTable';
import { ChaptersDetail } from './ChaptersDetail';
import { Page } from 'common/components/layout/Page';

export interface ChaptersProps {
  appState: AppState;
  entityActions: EntityActions;
}
export interface ChaptersState {
  isReady: boolean;
  savedAt: Date;
  error?: string;
  editChapter?: Chapter;
  reloadAt: Date;
}
const NEW_CHAPTER: Chapter = {};

export class Chapters extends React.Component<ChaptersProps & RouteComponentProps<{}>, ChaptersState> {
  state: ChaptersState = {
    isReady: false,
    savedAt: new Date(),
    reloadAt: new Date(),
  };

  handleAdd = () => {
    this.setState({ editChapter: NEW_CHAPTER });
  };

  handleEdit = (chapter: Chapter) => {
    this.setState({ editChapter: chapter });
  };

  handleCancelDialog = () => {
    this.setState({ editChapter: undefined });
  };

  handleSaveDialog = (id: string) => {
    this.props.entityActions.refetch(EntityType.CHAPTER, id);
    this.setState({ editChapter: undefined, reloadAt: new Date() });
  };

  handleClickRow = (id: string) => {
    this.props.history.push('/chapters/' + id);
  };

  render() {
    return (
      <div>
        {this.state.error && (
          <div className="alert alert-danger" style={{ marginTop: 20 }}>
            {this.state.error}
          </div>
        )}
        <Route
          path="/chapters"
          exact={true}
          render={props => (
            <Page
              title="Chapters"
              primaryAction={{
                shouldRender: true,
                onClick: this.handleAdd,
                label: 'Add Chapter',
              }}
            >
              {this.state.error && (
                <div className="alert alert-danger" style={{ marginTop: 20 }}>
                  {this.state.error}
                </div>
              )}
              <div className="card card-responsive">
                <div className="p-3 p-sm-4">
                  <ChaptersTable
                    appState={this.props.appState}
                    entityActions={this.props.entityActions}
                    reloadAt={this.state.reloadAt}
                    onClick={this.handleClickRow}
                    onEdit={this.handleEdit}
                  />
                  <ChaptersDialog
                    chapter={this.state.editChapter}
                    onSave={this.handleSaveDialog}
                    onCancel={this.handleCancelDialog}
                  />
                </div>
              </div>
            </Page>
          )}
        />
        <Route path="/chapters/:id" render={props => <ChaptersDetail id={props.match.params.id} {...this.props} />} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Chapters/Chapters.tsx